import { PICTOGRAM_TYPES } from '../constants/pictogram-types.js';

// este es la estrucutura de las opciones de configuración de las capas
// Si se desea agregas mas opciones adicionar childdren si ya no nay mas opciones pones el
// el nombre del componente que se renderizara
//
// Campo opcional `appliesTo`: array de tipos de pictograma donde se muestra
// la opción. Si no está definido, aplica a todos los tipos.
const configGeneralOptions = [
  {
    code: 'config_general',
    name: 'Configuración general',
    description: 'Configuracion fechas programadas de inicio y fin.',
    icon: 'cog',
    order: 0,
    type: 'item',
    component: {
      name: 'LayerConfig',
      props: {}
    }
  },
  {
    code: 'config_statuses_progress',
    name: 'Estados de progreso',
    description: 'Definicion de los estados de progreso, como se calcula el progreso, quienes pueden dar avance, configurar acciones masivas.',
    icon: 'cog',
    order: 1,
    type: 'item',
    component: {
      name: 'LayerStatusesConfig',
      props: {
        configType: 'progress'
      }
    }
  },
  {
    code: 'config_statuses_incidents',
    name: 'Estados de incidencias',
    description: 'Definicion de los estados de incidencias, quienes pueden dar incidencia, configurar acciones masivas.',
    icon: 'cog',
    order: 2,
    type: 'item',
    component: {
      name: 'LayerStatusesConfig',  // Usa el mismo componente
      props: {
        configType: 'incident'  // Con configType diferente
      }
    }
  },
  {
    code: 'config_ratios',
    name: 'Ratios',
    description: 'Definir ratios de la capa.',
    icon: 'cog',
    order: 3,
    type: 'item',
    appliesTo: [PICTOGRAM_TYPES.MECHANICAL],
    component: {
      name: 'LayerRatiosConfig',
      props: {}
    }
  },
  // Deshabilitada: el componente `LayerValidationFlowConfig` aún no existe (no está
  // creado ni registrado en list-items-view.vue), así que la opción mostraba el error
  // "Componente no definido". Se deja comentada para reactivarla cuando se implemente.
  // {
  //   code: 'config_validation_flow',
  //   name: 'Flujo de validación',
  //   description: 'Definir flujo de validación que daran avance a la capa.',
  //   icon: 'cog',
  //   order: 4,
  //   type: 'item',
  //   appliesTo: [PICTOGRAM_TYPES.MECHANICAL],
  //   component: {
  //     name: 'LayerValidationFlowConfig',
  //     props: {}
  //   }
  // },
  {
    code: 'import_extra_attributes',
    name: 'Importar atributos extra',
    description: 'Importar atributos extra desde un archivo CSV.',
    icon: 'cog',
    order: 6,
    type: 'item',
    appliesTo: [PICTOGRAM_TYPES.MECHANICAL],
    component: {
      name: 'LayerImportExtraAttributes',  // Usa el mismo componente
      props: {}
    }
  },
  // { // habilitar en el futuro
  //   code: 'config_bulk_actions',
  //   name: 'Acciones masivas',
  //   description: 'Replicar configuración o estados de esta capa al resto del pictograma.',
  //   icon: 'copy',
  //   order: 7,
  //   type: 'item',
  //   component: {
  //     name: 'LayerBulkActions',
  //     props: {}
  //   }
  // },
]

// Opciones específicas por tipo de capa
// Formato: config{layerCode}Options (ejemplo: configStructuresOptions, configModulesOptions)
// const configStructuresOptions = [...]
// const configModulesOptions = [...]

// Registro de opciones específicas por código de capa
const layerSpecificOptionsRegistry = {
  // structures: configStructuresOptions,
  // modules: configModulesOptions,
  // Agregar aquí nuevas opciones específicas cuando se creen
}

/**
 * Obtiene todas las opciones de configuración disponibles para una capa.
 * Busca dinámicamente si existe opciones específicas en el registro.
 * Filtra por tipo de pictograma si se proporciona:
 *   - Opciones sin appliesTo aplican a todos los tipos.
 *   - Opciones con appliesTo solo se incluyen si pictogramType está en el array.
 *
 * @param {Object} layer - Objeto de capa con {id, code, config}
 * @param {String} [pictogramType] - Tipo del pictograma (PICTOGRAM_TYPES.*).
 *                                   Si se omite, no filtra (back-compat).
 * @returns {Array} Opciones aplicables ordenadas por 'order'.
 */
const getConfigLayerOptions = function (layer, pictogramType = null) {
  // Si no hay layer, retornar opciones generales sin modificar
  if (!layer) {
    return configGeneralOptions.sort((a, b) => a.order - b.order);
  }

  // Buscar opciones específicas de la capa en el registro usando layer.code
  const specificOptions = layerSpecificOptionsRegistry[layer.code] || [];

  // Combinar opciones generales primero, luego las específicas
  const allOptions = [
    ...configGeneralOptions,
    ...specificOptions
  ];

  // Filtro por tipo de pictograma (si fue provisto)
  const visibleOptions = pictogramType
    ? allOptions.filter(o => !o.appliesTo || o.appliesTo.includes(pictogramType))
    : allOptions;

  // Mapear las opciones para agregar el layer como prop en cada componente
  const optionsWithLayer = visibleOptions.map(option => {
    // Si la opción tiene un componente, agregar layer a sus props
    if (option.component && option.component.props) {
      return {
        ...option,
        component: {
          ...option.component,
          props: {
            ...option.component.props,
            layer: layer
          }
        }
      };
    }
    return option;
  });

  // Ordenar por el campo 'order'
  return optionsWithLayer.sort((a, b) => a.order - b.order);
}

export { getConfigLayerOptions }
